const STORAGE_KEY = "selectedNavigationContext";

const isBrowser =
    typeof window !== "undefined" &&
    typeof window.localStorage !== "undefined";

const normalizeValue = (value) => (value == null ? null : String(value));

const safeParse = (value) => {
    if (!value) return null;

    try {
        return JSON.parse(value);
    } catch (error) {
        return null;
    }
};

const buildRoleSnapshot = (role) => {
    if (!role) return null;

    return {
        id: role.id ?? null,
        code: role.code ?? null,
        name: role.name ?? null,
        moduleId: role.moduleId ?? null,
        moduleName: role.moduleName ?? null,
    };
};

const buildModuleSnapshot = (module, role) => {
    if (module) {
        return {
            id: module.id ?? module.moduleId ?? null,
            code: module.moduleCode ?? module.code ?? null,
            name: module.name ?? module.moduleName ?? null,
        };
    }

    if (!role || (role.moduleId == null && !role.moduleCode && !role.moduleName)) return null;

    return {
        id: role.moduleId ?? null,
        code: role.moduleCode ?? null,
        name: role.moduleName ?? null,
    };
};

export const readNavigationSelection = () => {
    if (!isBrowser) return null;
    return safeParse(window.localStorage.getItem(STORAGE_KEY));
};

export const writeNavigationSelection = (selection) => {
    if (!isBrowser) return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(selection));
};

export const clearNavigationSelection = () => {
    if (!isBrowser) return;
    window.localStorage.removeItem(STORAGE_KEY);
};

export const saveNavigationSelectionForRole = (role, userId) => {
    const previous = readNavigationSelection() || {};

    writeNavigationSelection({
        ...previous,
        userId: normalizeValue(userId ?? previous.userId),
        role: buildRoleSnapshot(role),
        module: buildModuleSnapshot(null, role) || previous.module || null,
    });
};

export const saveNavigationSelectionForModule = (module, userId) => {
    const previous = readNavigationSelection() || {};

    writeNavigationSelection({
        ...previous,
        userId: normalizeValue(userId ?? previous.userId),
        // A role is scoped to a module.  Keeping the previous role here makes a
        // later restore put the user back in the old module.
        role: null,
        module: buildModuleSnapshot(module, null),
    });
};
